import { Container, Row, Col } from 'reactstrap'

export default function SixSection() {
  const testimonials = [
    {
      text: '"Achei a plataforma perfeita para quem, como eu, está começando no tênis. Conheci uma comunidade super legal e agora jogo com muito mais frequência. Recomendo muito!"',
      author: 'Laís',
      meta: 'Nível D - São Paulo - SP',
    },
    {
      text: '"O aplicativo é excelente para me conectar com outros tenistas de níveis semelhantes e cria uma esfera de competitividade muito legal que nos estimula a continuar praticando o esporte."',
      author: 'Erick',
      meta: 'Nível B - Rio de Janeiro - RJ',
    },
    {
      text: '"Ninguém joga tênis sozinho. Neste sentido o App é completo. Você escolhe a quadra, desafia adversários e se motiva a subir no ranking."',
      author: 'Juan',
      meta: 'Nível C - Ji-Paraná, Rondônia',
    },
  ]

  return (
    <section className="social-proof-section px-3">
      <Container>
        <Row className="text-center mb-5">
          <Col>
            <h2 className="section-title text-primary fw-bold">
              Junte-se a milhares de tenistas
            </h2>
            <p className="section-subtitle text-black">
              Veja o que os nossos usuários estão dizendo
            </p>
          </Col>
        </Row>
        {/* Desktop grid */}
        <Row className="g-4 d-none d-md-flex">
          {testimonials.map((t, index) => (
            <Col key={index} md="4" className="testimonial">
              <div className="testimonial-content">
                <div className="stars">★★★★★</div>
                <p>{t.text}</p>
                <div className="testimonial-author">
                  <strong>{t.author}</strong>
                  <span>{t.meta}</span>
                </div>
              </div>
            </Col>
          ))}
        </Row>

        {/* Mobile horizontal scroll (no visible scrollbar) */}
        <Row className="d-md-none">
          <Col xs="12">
            <div
              style={{
                position: 'relative',
                marginLeft: '-1rem',
                marginRight: '-1rem',
                paddingLeft: '1rem',
                paddingRight: '1rem',
              }}
            >
              <div
                className="horizontal-scroll"
                style={{
                  display: 'flex',
                  overflowX: 'auto',
                  gap: '1rem',
                  scrollSnapType: 'x mandatory',
                  WebkitOverflowScrolling: 'touch',
                  paddingBottom: '0.5rem',
                }}
              >
                {testimonials.map((t, index) => (
                  <div
                    key={index}
                    style={{
                      flex: '0 0 85%',
                      scrollSnapAlign: 'center',
                    }}
                  >
                    <div className="testimonial">
                      <div className="testimonial-content">
                        <div className="stars">★★★★★</div>
                        <p>{t.text}</p>
                        <div className="testimonial-author">
                          <strong>{t.author}</strong>
                          <span>{t.meta}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
